import type { ContentBlock, EditorState } from 'draft-js';
import { RichUtils } from 'draft-js';
import styles from '../textSizeStyles.scss';

export type TextSizeBlockType = 'unstyled' | 'header-two' | 'header-three';

export const textSizeBlockTypes: Array<TextSizeBlockType> = [
  'header-two',
  'header-three',
  'unstyled',
];

export const textSizeStylesFn = (contentBlock: ContentBlock) => {
  const { type } = contentBlock.toJS();

  if (type === 'header-two') {
    return styles.headerTwo;
  } else if (type === 'header-three') {
    return styles.headerThree;
  }
  return '';
};

export const getActiveTextSize = (
  editorState: EditorState,
): TextSizeBlockType => {
  const startKey = editorState.getSelection().getStartKey();
  const contentBlock = editorState.getCurrentContent().getBlockForKey(startKey);
  const { type } = contentBlock.toJS();
  if (type === 'header-two' || type === 'header-three') {
    return type;
  }
  return 'unstyled';
};

export const preventBubblingUp = (
  event: React.MouseEvent<HTMLOrSVGElement>,
) => {
  event.preventDefault();
  event.stopPropagation();
};

export const getStateWithNewTextSize = (
  textAlignment: string,
  editorState: EditorState,
) => {
  return RichUtils.toggleBlockType(editorState, textAlignment);
};

export const createStateWithNormalText = (editorState: EditorState) => {
  if (getActiveTextSize(editorState) === 'unstyled') {
    return editorState;
  }
  return RichUtils.toggleBlockType(editorState, 'unstyled');
};

export const createStateWithTitle = (editorState: EditorState) => {
  if (getActiveTextSize(editorState) === 'header-two') {
    return editorState;
  }
  return RichUtils.toggleBlockType(editorState, 'header-two');
};

export const createStateWithSubtitle = (editorState: EditorState) => {
  if (getActiveTextSize(editorState) === 'header-three') {
    return editorState;
  }
  return RichUtils.toggleBlockType(editorState, 'header-three');
};
